module.exports = __webpack_public_path__ + "static/img/register-suc.0c0901bb.png";